import {
	useGetWorkspaceBudgetSettings,
	useSetWorkspaceBudgetSettings,
} from '@repo/api-codegen';
import { useState } from 'react';
import { BUDGET_DEFAULTS, BUDGET_LIMITS } from './constants';

interface UseEditBudgetSettingsModalProps {
	onSuccess?: () => void;
}

export function useEditBudgetSettingsModal({
	onSuccess,
}: UseEditBudgetSettingsModalProps) {
	const { data: budgetSettings, refetch: refetchBudgetSettings } =
		useGetWorkspaceBudgetSettings({});
	const { mutate: setBudgetSettings } = useSetWorkspaceBudgetSettings({
		onSuccess: () => {
			refetchBudgetSettings();
			onSuccess?.();
		},
	});

	const [budgetError, setBudgetError] = useState<string | null>(null);

	const validateBudget = (value: number | ''): string | null => {
		if (value === '' || value === null || value === undefined) {
			return 'Spend limit is required';
		}
		if (value < BUDGET_LIMITS.MIN) {
			return `Spend limit must be at least $${BUDGET_LIMITS.MIN}`;
		}
		if (value > BUDGET_LIMITS.MAX) {
			return `Spend limit cannot exceed $${BUDGET_LIMITS.MAX}`;
		}
		return null;
	};

	const handleSave = (monthlyBudget: number) => {
		const budgetValidation = validateBudget(monthlyBudget);

		setBudgetError(budgetValidation);

		if (budgetValidation) {
			return;
		}

		setBudgetSettings({
			body: {
				monthly_budget: monthlyBudget,
				enabled: budgetSettings?.enabled ?? false,
			},
		});
	};

	const handleBudgetChange = (value: number | '') => {
		const budget = value || BUDGET_DEFAULTS.MONTHLY_BUDGET;
		const error = validateBudget(value);
		setBudgetError(error);
		if (!error) {
			handleSave(budget);
		}
	};

	return {
		budgetSettings,
		budgetError,
		handleBudgetChange,
	};
}
